import { Typography, TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Action } from '../../api/gql';
import { actionToTransMap } from '../../utils/maps';

export const ActionName = ({ action, ...rest }: { action: Action } & TypographyProps) => {
  const { t } = useTranslation();
  const key = actionToTransMap[action];

  return <Typography {...rest}>{t(key)}</Typography>;
};
